namespace Matrix.Rebalancer {
    export interface ModellingViewForm {
        ViewCode: Serenity.StringEditor;
        Name: Serenity.StringEditor;
        ModelTypeCode: FormatLookupEditor;
        ColumnSetCode: FormatLookupEditor;
        OwnershipBasisCode: FormatLookupEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class ModellingViewForm extends Serenity.PrefixedContext {
        static formKey = 'Rebalancer.ModellingView';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ModellingViewForm.init)  {
                ModellingViewForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = FormatLookupEditor;
                var w2 = StaticTextBlock;
                var w3 = ReadOnlyDateTime;

                Q.initFormType(ModellingViewForm, [
                    'ViewCode', w0,
                    'Name', w0,
                    'ModelTypeCode', w1,
                    'ColumnSetCode', w1,
                    'OwnershipBasisCode', w1,
                    'CreatedBy', w2,
                    'CreatedWhen', w3,
                    'UpdatedBy', w2,
                    'UpdatedWhen', w3,
                    'Version', w2
                ]);
            }
        }
    }
}
